var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Flex } from '@creditas-ui/layout';
import { styled } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';
var transitionDuration = 300;

var onOpenTransition = _ref => {
  var {
    transitionState,
    theme
  } = _ref;
  return transitionState === 'entered' && "opacity: ".concat(theme.backdrop('container.opacity'), ";}");
};

var onCloseTransition = _ref2 => {
  var {
    transitionState
  } = _ref2;
  return transitionState === 'exiting' && 'opacity: 0;';
};

var BackdropElement = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100vw;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  transition: opacity ", "ms ease-in-out;\n  opacity: 1;\n  ", "\n  ::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ", ";\n    transition: opacity ", "ms ease-in-out;\n    opacity: 0;\n    z-index: -1;\n    ", "\n  }\n"])), transitionDuration, onCloseTransition, selectTheme('backdrop.container.backgroundColor'), transitionDuration, onOpenTransition);
export { BackdropElement, transitionDuration };
//# sourceMappingURL=Backdrop.style.js.map